module.exports = __webpack_public_path__ + "media/landing-page/integration-image-55441b6b.png";